<!--
 * @Author: liushumin
 * @Date: 2022-09-14 18:05:05
 * @LastEditTime: 2022-09-29 14:48:58
 * @LastEditors: liushumin
-->
<template>
  <el-dialog
    title="查看物流"
    :visible.sync="dialogVisible_logistics"
    width="30%"
    :before-close="handleClose"
  >
    <div v-if="logisticsInfo" class="logisticsInfo">
      <p>发货时间：{{ logisticsInfo.saleOrderTime }}</p>
      <p>承运人：{{ logisticsInfo.contacts }}</p>
      <p>承运人联系方式：{{ logisticsInfo.telPhone }}</p>
      <p>备注：{{ logisticsInfo.remark }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleClose">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  // , "logisticsInfo"
  props: ["openStatus", "orderId"],
  data() {
    return {
      dialogVisible_logistics: false,
      logisticsInfo: {
        saleOrderTime: "",
        contacts: "",
        telPhone: "",
        remark: "",
      },
    };
  },
  watch: {
    openStatus(val1, val2) {
      this.dialogVisible_logistics = this.openStatus;
    },
    orderId(val1, val2) {
      console.log(val1, val2);
      if (val1 != "") {
        this.getLogisticsList();
      }
    },
  },
  mounted() {},
  methods: {
    handleClose() {
      this.dialogVisible_logistics = false;
      this.$emit("closeStatus", true);
    },
    getLogisticsList() {
      this.$http.szOrder.getLogistics({ orderId: this.orderId }).then((res) => {
        if (res.status == 1) {
          if (res.data != null) {
            this.logisticsInfo = res.data;
          }else{
            this.logisticsInfo = []
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../../../styles/order-global.scss';
</style>